import { render, staticRenderFns } from "./AdmissionDetails.vue?vue&type=template&id=c6c7b866"
import script from "./AdmissionDetails.vue?vue&type=script&lang=js"
export * from "./AdmissionDetails.vue?vue&type=script&lang=js"
import style0 from "./AdmissionDetails.vue?vue&type=style&index=0&id=c6c7b866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports